(() => {
  const init = () => {
    const hero = document.querySelector('.hk188-hero-wrap');
    const recipe = document.querySelector('.article-template__content .hk-recipe-text');
    if (!hero || !recipe || hero.dataset.hk190Enhanced === 'true') return;
    const headings = Array.from(recipe.children).filter((node) => node.tagName === 'H2');
    const find = (re) => headings.find((node) => re.test((node.textContent || '').trim()));
    const entries = [
      { label: 'Ingrediënten', heading: find(/^ingrediënten\b/i), id: 'hk190-ingredients' },
      { label: 'Bereiding', heading: find(/^zo maak je het\b/i), id: 'hk190-method' },
      { label: 'Veelgestelde vragen', heading: find(/^veelgestelde vragen\b/i), id: 'hk190-faq' }
    ].filter((entry) => Boolean(entry.heading));
    for (const entry of entries) {
      if (!entry.heading.id) entry.heading.id = entry.id;
      else entry.id = entry.heading.id;
    }
    const navigation = document.createElement('nav');
    navigation.className = 'hk190-jump-nav';
    navigation.setAttribute('aria-label', 'Snel navigeren binnen dit recept');
    const title = document.createElement('span');
    title.className = 'hk190-jump-label';
    title.textContent = 'Snel naar';
    navigation.append(title);
    const basket = document.getElementById('hk-recipe-ingredients');
    if (basket) {
      const anchor = document.createElement('a');
      anchor.href = '#hk-recipe-ingredients';
      anchor.textContent = 'Boodschappen';
      navigation.append(anchor);
    }
    for (const entry of entries) {
      const anchor = document.createElement('a');
      anchor.href = '#' + entry.id;
      anchor.textContent = entry.label;
      navigation.append(anchor);
    }
    if (typeof window.print === 'function') {
      const printButton = document.createElement('button');
      printButton.className = 'hk190-print';
      printButton.type = 'button';
      printButton.textContent = 'Print recept';
      printButton.addEventListener('click', () => window.print());
      navigation.append(printButton);
    }
    if (entries.length || basket) hero.insertAdjacentElement('afterend', navigation);
    const method = entries.find((entry) => entry.id === 'hk190-method');
    if (method) {
      let list = method.heading.nextElementSibling;
      while (list && list.tagName !== 'OL' && list.tagName !== 'H2') list = list.nextElementSibling;
      if (list && list.tagName === 'OL') {
        const steps = Array.from(list.children).filter((node) => node.tagName === 'LI');
        if (steps.length > 0 && steps.length <= 25) {
          list.classList.add('hk190-enhanced');
          const tracker = document.createElement('div');
          tracker.className = 'hk190-progress-tools';
          tracker.setAttribute('role', 'group');
          tracker.setAttribute('aria-label', 'Voortgang bereidingsstappen');
          const label = document.createElement('span');
          label.className = 'hk190-progress-label';
          label.setAttribute('role', 'status');
          label.setAttribute('aria-live', 'polite');
          const meter = document.createElement('progress');
          meter.className = 'hk190-progress';
          meter.max = steps.length;
          meter.value = 0;
          const reset = document.createElement('button');
          reset.type = 'button';
          reset.className = 'hk190-reset';
          reset.textContent = 'Opnieuw beginnen';
          reset.disabled = true;
          tracker.append(label, meter, reset);
          list.insertAdjacentElement('beforebegin', tracker);
          const buttons = [];
          const refresh = () => {
            const complete = buttons.filter((button) => button.getAttribute('aria-pressed') === 'true').length;
            meter.value = complete;
            label.textContent = complete + ' van ' + steps.length + ' stappen gedaan';
            reset.disabled = complete === 0;
            tracker.classList.toggle('hk190-all-done', complete === steps.length);
          };
          steps.forEach((step, index) => {
            step.classList.add('hk190-step');
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'hk190-step-toggle';
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-label', 'Stap ' + (index + 1) + ' afvinken');
            button.textContent = String(index + 1);
            button.addEventListener('click', () => {
              const done = button.getAttribute('aria-pressed') !== 'true';
              button.setAttribute('aria-pressed', done ? 'true' : 'false');
              button.setAttribute('aria-label', 'Stap ' + (index + 1) + (done ? ' opnieuw openen' : ' afvinken'));
              button.textContent = done ? '✓' : String(index + 1);
              step.classList.toggle('hk190-step-done', done);
              refresh();
            });
            step.prepend(button);
            buttons.push(button);
          });
          reset.addEventListener('click', () => {
            buttons.forEach((button, index) => {
              button.setAttribute('aria-pressed', 'false');
              button.setAttribute('aria-label', 'Stap ' + (index + 1) + ' afvinken');
              button.textContent = String(index + 1);
              steps[index].classList.remove('hk190-step-done');
            });
            refresh();
            buttons[0]?.focus();
          });
          refresh();
        }
      }
    }
    hero.dataset.hk190Enhanced = 'true';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();